import React from "react";
import {fetchRestaurants, sortRestaurants} from "../reducers/restaurants";
import {setCameFromSlide, setMainPageIndex} from "../reducers/app";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import Api from "../Api";
import IntManager, {t} from "../IntManager";
import Swiper from "react-id-swiper";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import $ from "jquery";
import {Link, Redirect} from "react-router-dom";
import {Power3, TimelineLite} from 'gsap';
import Parallax from 'parallax-js';

const activeClass = '_active';
const interleaveOffset = -.5;

const sliderConfig = {
    loop: true,
    uniqueNavElements: false,
    speed: 1000,
    preloadImages: false,
    lazy: {
        loadPrevNext: true
    },
    watchSlidesProgress: true,
    mousewheel: true,
    keyboard: true,
    hashNavigation: true,
    navigation: {
        nextEl: '.js-slider-next',
        prevEl: '.js-slider-prev'
    },
    on: {
        progress: function (progress) {
            const inst = this;

            for (let i = 0; i < inst.slides.length; i++) {

                const slide = inst.slides[i];
                let translate, innerTranslate;
                progress = slide.progress;

                if (progress > 0) {
                    translate = progress * inst.width;
                    innerTranslate = translate * interleaveOffset;
                }
                else {
                    innerTranslate = Math.abs(progress * inst.width) * interleaveOffset;
                    translate = 0;
                }

                $(slide).css({
                    transform: 'translate3d(' + translate + 'px,0,0)'
                });

                $(slide).find('.slide-inner').css({
                    transform: 'translate3d(' + innerTranslate + 'px,0,0)'
                });
            }
        },

        touchStart: function () {
            const inst = this;

            for (let i = 0; i < inst.slides.length; i++) {
                $(inst.slides[i]).css({transition: ''});
            }
        },

        setTransition: function (speed) {
            const inst = this;

            for (let i = 0; i < inst.slides.length; i++) {
                $(inst.slides[i]).find('.slide-inner').addBack().css({transitionDuration: speed + 'ms'});
            }
        }
    }
};

class Home extends SeoComponent {
    static fetchData(store) {
        return store.dispatch(fetchRestaurants());
    }

    constructor(props, context) {
        super(props, context);

        this.onChangePageAnimation = this.onChangePageAnimation.bind(this);
        this.onLogoClick = this.onLogoClick.bind(this);

        this.state = {
            redirect: null
        };
    }

    componentDidMount() {
        //TODO After handling backward animation call "this.props.setCameFromSlide(false)"
        if (this.props.cameFromSlide) {
            this.parallax && this.parallax.disable();
            this.backPageAnimation();
            this.props.setCameFromSlide(false);
        }
        this.props.fetchRestaurants();

        $('.menu__list-item:first').on('click',()=> {
            this.props.setMainPageIndex(2);
            this.slider && this.slider.swiper.slideTo(2);
        });
    }

    componentWillUnmount() {
        this.parallax && this.parallax.disable();
    }

    tweenComplete(a, b) {
        a.setState({redirect: b});
    }

    onChangePageAnimation(e, url) {
        e.preventDefault();
        this.props.setCameFromSlide(true);

        const tl = new TimelineLite({onComplete: this.tweenComplete, onCompleteParams: [this, url]});
        const timer = .5;

        tl.to('.js-fade', timer, {autoAlpha: 0, ease: Power3.easeOut})
            .to('.js-slideup', timer, {y: '-=100%', ease: Power3.easeOut}, '-=' + timer)
            .fromTo('.swiper-slide-active .layer', timer + .2, {scale:1}, {
                scale: .91,
                x: 0,
                y: 0,
                ease: Power3.easeOut
            },  '-=' + timer - .15);
    }

    backPageAnimation() {
        const tl = new TimelineLite({onComplete: () => {
            this.parallax && this.parallax.enable();
        }});
        const transition = Power3.easeOut;
        const timer = .5;

        tl.fromTo('.swiper-slide-active .layer', timer, {scale: .91, x: 0, y: 0}, {scale: 1},'+=.2')
            .fromTo('.js-fade', timer, {autoAlpha: 0}, {autoAlpha: 1, ease: transition},'-=' + timer)
            .fromTo('.js-slideup', timer, {y: "-=100%"}, {y: "+=100%", ease: transition},'-=' + timer);

    }

    onLogoClick() {
        this.slider && this.slider.swiper.slideTo(1);
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect}/>;
        }

        this.setMetaTags('Гастрономический центр «Зарядье»', 'Гастрономический центр «Зарядье» — это современный фуд-маркет, где на 8 гурмэ-островах готовят блюда по переосмысленным рецептам кухни российских регионов.');

        let content;
        if (this.props.error) {
            content = <div>Не удалось получить данные с сервера</div>
        } else if (this.props.loading) {
            content = <div className="u-fit u-fixed">Загрузка...</div>
        } else {
            content = this.renderSlider()
        }

        return <LayoutComponent footer={this.renderFooter()} extraContent={this.renderExtraContent()}
                                onLogoClick={this.onLogoClick} routerMatch={this.props.match}>
            {content}
        </LayoutComponent>
    }

    renderFooter() {
        const pages = [];

        let i = 1;
        for (let k in this.props.restaurants) {
            if (this.props.restaurants.hasOwnProperty(k)) {
                pages.push(<li key={i} className="pagination__item relative" data-index={i}>
                    <span className="pagination__text u-color--white u-absolute">0{i}</span>
                </li>);

                i++;
            }
        }

        return <div className="nav__footer u-absolute u-pos-bl u-pos-r js-fade">
            <div className="nav__socials hide-phone">
                <a href="https://t.me/zaryadye_gastrocenter" className="nav__soc-item u-inline-block relative nav__soc-item_telegram" target="_blank"  rel="noopener noreferrer"/>
                {/*<a href="//www.facebook.com/zaryadyegastrocenter/" className="nav__soc-item u-inline-block relative nav__soc-item_facebook" target="_blank" rel="noopener noreferrer"/>*/}
            </div>
            <ul className="nav__pagination pagination ui-light">
                {pages}
            </ul>
        </div>;
    }

    renderExtraContent() {
        return <React.Fragment>
            <div className="nav__slider-arrow u-block u-absolute slider-arrow _arrow-left js-slider-prev js-fade">
                <span className="u-block u-absolute u-overflow-h slider-arrow__base">
                    <span className="slider-arrow__circle u-absolute u-pos-tl u-fit u-block u-overflow-h"/>
                </span>
                <span className="slider-arrow__inner u-pos-tl u-absolute u-fit u-block">
                    <span className="slider-arrow__icon u-absolute u-overflow-h u-block">
                        <span className="slider-arrow__bar u-absolute u-inline-block u-white-background"/>
                        <svg className="slider-arrow__triangle u-absolute u-fill--white u-block u-pos-tl">
                            <use xlinkHref="/static/media/svg-symbols.svg#triangle-right"/>
                        </svg>
                    </span>
                </span>
            </div>
            <div className="nav__slider-arrow u-block u-absolute slider-arrow _arrow-right js-slider-next js-fade">
                <span className="u-block u-absolute u-overflow-h slider-arrow__base">
                    <span className="slider-arrow__circle u-absolute u-pos-tl u-fit u-block u-overflow-h"/>
                </span>
                <span className="slider-arrow__inner u-pos-tl u-absolute u-fit u-block">
                    <span className="slider-arrow__icon u-absolute u-overflow-h u-block">
                        <span className="slider-arrow__bar u-absolute u-inline-block u-white-background">
                        </span>
                        <svg className="slider-arrow__triangle u-absolute u-fill--white u-block u-pos-tl">
                            <use xlinkHref="/static/media/svg-symbols.svg#triangle-right"/>
                        </svg>
                    </span>
                </span>
            </div>
        </React.Fragment>;
    }

    renderSlide(restaurant) {
        const url = IntManager.getUrl(`/restaurants/${restaurant.alias}`);

        const layerStyle =  Api.getImage(restaurant.image);

        return <div key={restaurant.id} className="swiper-slide u-overflow-h">
            <div className="slide-inner u-absolute u-fit u-pos-tl u-black-background">
                <div className="u-overlay u-absolute u-fit u-pos-tl"></div>
                <div className="scene relative">
                    <div className="layer u-absolute swiper-lazy" data-depth={0.3} data-background={layerStyle}>
                    </div>
                </div>
                <div className="slide__content u-absolute ui-light">
                    <Link to={url} onClick={(e) => this.onChangePageAnimation(e, url)}>
                        <h2 className="slide__title u-color--white u-block"
                            dangerouslySetInnerHTML={{__html: restaurant.slideTitle}}/>
                    </Link>
                    <div className="slide__text u-color--white u-overflow-h">
                        <p className="u-block js-slideup">{restaurant.shortDescription}</p>
                    </div>
                    <Link className="slide__message--clone u-block relative u-overflow-h slide-message phone-only" to={url}
                          onClick={(e) => this.onChangePageAnimation(e, url)}>
                        <span className="slide-message__wrapper u-color--white u-block js-slideup ">
                            <span className="slide-message__text u-valign-middle u-inline-block">
                                {t('more')}
                            </span>
                            <span
                                className="slide-message__icon u-valign-middle u-inline-block relative u-overflow-h">
                                <svg className="slider-message__triangle u-absolute u-fill--white">
                                    <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                </svg>
                                <svg className="slider-message__triangle u-absolute u-fill--white _clone">
                                    <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                </svg>
                                <span className="slider-message__circle u-pos-tl u-absolute u-fit u-block"></span>
                            </span>
                        </span>
                    </Link>
                </div>
                <Link className="slide__message u-absolute u-overflow-h slide-message ui-light hide-phone" to={url}
                      onClick={(e) => this.onChangePageAnimation(e, url)}>
                        <span className="slide-message__wrapper u-color--white u-block js-slideup">
                            <span className="slide-message__text u-valign-middle u-inline-block">
                                {t('more')}
                            </span>
                            <span
                                className="slide-message__icon u-valign-middle u-inline-block relative u-overflow-h">
                                <svg className="slider-message__triangle u-absolute u-fill--white">
                                    <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                </svg>
                                <svg className="slider-message__triangle u-absolute u-fill--white _clone">
                                    <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                </svg>
                                <span
                                    className="slider-message__circle u-pos-tl u-absolute u-fit u-block"></span>
                            </span>
                        </span>
                </Link>
            </div>
        </div>
    }

    renderSlider() {
        const slides = [];
        const restaurants = sortRestaurants(this.props.restaurants);

        for (let k in restaurants) {
            if (restaurants.hasOwnProperty(k)) {
                slides.push(this.renderSlide(restaurants[k]));
            }
        }

        const slideChangeTransitionStart = () => {
            const owner = this;
            return function () {
                const paginationItem = document.querySelectorAll('.pagination__item');

                $(paginationItem).removeClass(activeClass);
                $(paginationItem[this.realIndex]).addClass(activeClass);

                owner.parallax && owner.parallax.disable();

                const slide = $('.swiper-slide-active').find('.scene').get(0);
                if (slide) {
                    owner.parallax = new Parallax(slide);
                }
            }
        };

        const slideChange = () => {
            const owner = this;
            return function () {
                owner.props.setMainPageIndex(this.realIndex);
            }
        };

        const init = () => {
            const owner = this;
            return function () {
                $('.swiper-slide-duplicate a').on('click', function (e) {
                    owner.onChangePageAnimation(e, $(this).attr('href'))
                });
            }
        };

        sliderConfig.on.slideChangeTransitionStart = slideChangeTransitionStart();
        sliderConfig.on.slideChange = slideChange();
        sliderConfig.on.init = init();
        sliderConfig.initialSlide = this.props.initialSlide;

        return <Swiper {...sliderConfig} ref={(ref) => this.slider = ref}>
            {slides}
        </Swiper>;
    }
}

const mapStateToProps = (state, props) => {
    return {
        restaurants: state.restaurants.items,
        error: state.restaurants.error,
        loading: state.restaurants.loading,
        initialSlide: state.app.mainPageIndex,
        cameFromSlide: state.app.cameFromSlide,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRestaurants,
    setMainPageIndex,
    setCameFromSlide
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/js/components/Home.js